import { tree } from '@/util/base'

//判定key是否选中
const isChecked = (data ,keys, key) => {
  let children = data.filter( i => i.parentId == key)
  if( children.length == 0 ){
    return keys.includes(key)
  }else{
    return children.every( i => isChecked(data , keys, i.id))
  }
}
const setChecked = (data, keys, expand = false) => {
  for(let i of data ){
    if(keys.includes(i.id)){
      i.checked = true
    }else{
      i.checked = false
    }
    i.expand = expand
  }
}

const updateChildren = (d , checked) => {
  for(let i of (d.children || [])){
    i.checked = checked
    if(i.children) updateChildren(i , checked)
  }
}

const updateAncient = (d , raw) => {
  let parent = raw.find(i => i.id == d.parentId)
  if(parent){
    let allchecked = parent.children.every(i => i.checked)
    let somechecked = parent.children.some(i => i.checked)
    if( allchecked ){
      parent.checked = true
      parent.indeterminate = false
    }else{
      parent.checked = true
      parent.indeterminate = false
    }

    if(parent.parentId) updateAncient(parent , raw)
  }
}

const updateChecked = (item , data) => {
  
  updateChildren(item , item.checked)

  if(item.checked){
    updateAncient(item , data)
    //处理父级
  }else{
   
  }
}


export default {
  name: 'AuthTree',
  data() {
    return {
      authTree: [],
      _raw: []
    }
  },
  props: {
    //v-model 语法糖
    checkedKeys: {
      default: function() {
        return []
      }
    },
    expand: {
      type: Boolean,
      default: true
    },
    height: {
      default: 'auto'
    },
    all:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    checkedKeys(val) {
      if (this._raw && val !== undefined && val !== null) {
        setChecked(this._raw, val, this.expand)
      }
    }
  },
  created() {
    let all = this.all;
    this.$request.menuQueryAll(all).then(resp => {
      if (!resp.code) {
        this._raw = resp.data.sort((a,b) => a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0).map(i => ({ parentId: i.parentId, id: i.id, title: i.name, checked: false }))
        setChecked(this._raw, this.checkedKeys, this.expand)
        let treeData = tree(this._raw)
        //fix(treeData)
        this.authTree = treeData
      }
    })
  },
  methods: {
    change(v , item) {
      updateChecked(item , this._raw)
    },
    getChecked() {
      return this.$refs.tree.getCheckedAndIndeterminateNodes().map(i => ({ id: i.id }))
    }
  },
  render(){
    return <div style={{height:this.height , overflowY:'auto'}}>
      <Tree ref="tree" check-strictly={true} checkable size="sm" parentCheck data={this.authTree} on-on-check-change={this.change} show-checkbox />
    </div>
  }
}

